import {
  callApiAsync,
  getAssignableUsersList,
  getExecutedVsNoProjectedDetail,
  getExecutedVsProjectedDetail,
  getindicatorsExecutedvsNoProjected,
  getindicatorsExecutedvsProjected,
  getIndicatorTaskDeletedData,
  getIndicatorTaskDeletedDetail,
  getIndicatorUnplannedExecuted,
  getIndicatorUnplannedExecutedDetails,
  getManagementChartExecutedVsNOProjectedByProcessData,
  getManagementExecutedVsNOProjectedByProcess,
  getManagementExecutedVsProjectedByProcess,
  getManagementTableExecutedVsProjectedByProcessData,
  getPlannedNotExecutedData,
  getPlannedNotExecutedIndicators,
  getTaskYears
} from "../../services/apiService";
import { getCurrentYear } from "../../utils/dateUtils";
import { getCookie } from "../../utils/getCookie";

const userSesion = getCookie("sesion");
const userId = userSesion?.id_usuario;

const parseWeekRange = (range) => {
  if (!range) return { startDate: null, endDate: null };

  const [start, end] = String(range)
    .split("a")
    .map((p) => p.trim());

  return {
    startDate: start || null,
    endDate: end || null
  };
};

export const getAssignableUsersData = async (
  user_id,
  all = false,
  setAssignableList
) => {
  await callApiAsync(
    () => getAssignableUsersList(user_id, all),
    (data) => {
      setAssignableList(data);
    }
  );
};

export const getTaskYearsSelect = async (setYears, setValue, getChartData) => {
  await callApiAsync(
    () => getTaskYears(),
    (data) => {
      setYears(data);
      setValue("year", getCurrentYear());
      setValue("year2", getCurrentYear());
      getChartData();
    }
  );
};

export const getindicatorsExecutedvsProjectedData = async (
  year,
  month,
  dateRange,
  setChartData,
  setCatsData,
  setSummary
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getindicatorsExecutedvsProjected({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      setChartData(data.graph);
      setSummary(data.summary);
      setCatsData(
        data.summary?.classification_pct || { A: 0, B: 0, C: 0, D: 0 }
      );
    }
  );
};

export const getExecutedVsProjectedDetailData = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE,
  targetId = null
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);
  const start = startDate || "null";
  const end = endDate || "null";

  const payload = {
    year,
    month,
    start_date: start,
    end_date: end,
    user_id: targetId ?? userId
  };

  await callApiAsync(
    () => getExecutedVsProjectedDetail(payload, page, ROWS_PER_PAGE),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};

export const getPlannedNotExecutedIndicatorsFn = async (
  year,
  month,
  dateRange,
  setCatsData,
  setSummary,
  setChartPlannedNotExcecuted
) => {
  if (!year || !month) return;

  let startDate, endDate;

  if (dateRange) {
    const parsed = parseWeekRange(dateRange);
    startDate = parsed.startDate;
    endDate = parsed.endDate;
  } else {
    const range = getMonthDateRange(year, month);
    startDate = range.startDate;
    endDate = range.endDate;
  }

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getPlannedNotExecutedIndicators({
        start_date: start,
        end_date: end,
        user_id: userId
      }),
    (resp) => {
      setCatsData(resp.porcentajes);
      setSummary(resp.summary);
      setChartPlannedNotExcecuted(resp.graph);
    }
  );
};

export const getPlannedNotExecutedDataFn = async (
  year,
  month,
  dateRange,
  setTableData,
  setDetailPage,
  setDetailTotal,
  detailPage,
  ROWS_PER_PAGE
) => {
  if (!year || !month) return;

  let startDate, endDate;

  if (dateRange) {
    const parsed = parseWeekRange(dateRange);
    startDate = parsed.startDate;
    endDate = parsed.endDate;
  } else {
    const range = getMonthDateRange(year, month);
    startDate = range.startDate;
    endDate = range.endDate;
  }

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getPlannedNotExecutedData({
        start_date: start,
        end_date: end,
        user_id: userId,
        page: detailPage,
        pageSize: ROWS_PER_PAGE
      }),
    (resp) => {
      setTableData(resp.items || []);
      setDetailPage(resp.page);
      setDetailTotal(resp.total || 0);
    }
  );
};

function getMonthDateRange(year, month) {
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);

  const format = (date) => {
    const d = String(date.getDate()).padStart(2, "0");
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const y = date.getFullYear();
    return `${y}-${m}-${d}`;
  };

  return {
    startDate: format(firstDay),
    endDate: format(lastDay)
  };
}

export const getindicatorsExecutedvsNoProjectedData = async (
  year,
  month,
  dateRange,
  setChartData,
  setCatsData,
  setSummary
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getindicatorsExecutedvsNoProjected({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      setChartData(data.graph);
      setSummary(data.summary);
      setCatsData(
        data.summary?.classification_pct || { A: 0, B: 0, C: 0, D: 0 }
      );
    }
  );
};

export const getExecutedVsNoProjectedDetailData = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE,
  targetId = null
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  const payload = {
    year,
    month,
    start_date: start,
    end_date: end,
    user_id: targetId ?? userId
  };

  await callApiAsync(
    () => getExecutedVsNoProjectedDetail(payload, page, ROWS_PER_PAGE),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};

export const getIndicatorUnplannedExecutedData = async (
  year,
  month,
  dateRange,
  setChartData,
  setSummary,
  setCatsData
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);
  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getIndicatorUnplannedExecuted({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      setCatsData(
        data.summary?.classification_delegated_pct || { A: 0, B: 0, C: 0, D: 0 }
      );
      setChartData(data.graph);
      setSummary(data.summary);
    }
  );
};

export const getIndicatorUnplannedExecutedDetailsData = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getIndicatorUnplannedExecutedDetails(
        {
          year,
          month,
          start_date: start,
          end_date: end,
          user_id: userId
        },
        page,
        ROWS_PER_PAGE
      ),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};

export const getManagementExecutedVsProjectedByProcessDATA = async (
  year,
  month,
  dateRange,
  setChartData,
  setSummary,
  setCatsData,
  processId
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);
  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getManagementExecutedVsProjectedByProcess({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId,
        process_id: processId
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      setCatsData(
        data.summary?.classification_delegated_pct || { A: 0, B: 0, C: 0, D: 0 }
      );
      setChartData(data.graph);
      setSummary(data.summary);
    }
  );
};

export const getManagementTableExecutedVsProjectedByProcess = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE,
  processId
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getManagementTableExecutedVsProjectedByProcessData(
        {
          year,
          month,
          start_date: start,
          end_date: end,
          user_id: userId,
          process_id: processId
        },
        page,
        ROWS_PER_PAGE
      ),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};

export const getIndicatorTaskDeletedChartData = async (
  year,
  month,
  dateRange,
  setChartData,
  setCatsData,
  setSummary
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);
  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getIndicatorTaskDeletedData({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId,
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      setChartData(data.graph);
      setSummary(data.summary);
      setCatsData(
        data.summary?.classification_deleted_pct || { A: 0, B: 0, C: 0, D: 0 }
      );
    }
  );
};

export const getIndicatorTaskDeletedDetailData = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getIndicatorTaskDeletedDetail(
        {
          year,
          month,
          start_date: start,
          end_date: end,
          user_id: userId,
        },
        page,
        ROWS_PER_PAGE
      ),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};

export const getManagementChartExecutedVsNOProjectedByProcessDATA = async (
  year,
  month,
  dateRange,
  setChartData,
  setSummary,
  setCatsData,
  processId
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);
  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getManagementChartExecutedVsNOProjectedByProcessData({
        year,
        month,
        start_date: start,
        end_date: end,
        user_id: userId,
        process_id: processId
      }),
    (resp) => {
      const data = resp?.data ?? resp;
      const graph = data.graph || {};
      setCatsData(
        graph.categories || { A: 0, B: 0, C: 0, D: 0 }
      );
      setChartData(graph);

      const proj = Array.isArray(graph.projected) ? graph.projected : [];
      const exec = Array.isArray(graph.executed) ? graph.executed : [];
      const totalProj = proj.reduce((a, b) => a + Number(b) || 0, 0);
      const totalExec = exec.reduce((a, b) => a + Number(b) || 0, 0);
      const compliancePct =
        totalProj > 0
          ? Number(((totalExec / totalProj) * 100).toFixed(2))
          : 0;
      let complianceLevel = "RED";
      let complianceColor = "#f9c7c5";
      let complianceMessage = "";
      if (compliancePct >= 67) {
        complianceLevel = "GREEN";
        complianceColor = "#c9f8d1";
        complianceMessage =
          "La mayoría de los procesos avanzan correctamente, reflejando compromiso y buena gestión humana.";
      } else if (compliancePct >= 34) {
        complianceLevel = "ORANGE";
        complianceColor = "#ffe0b3";
        complianceMessage =
          "El cumplimiento muestra avances pero hay margen de mejora en la ejecución de actividades no planificadas.";
      } else {
        complianceMessage =
          "El cumplimiento general está significativamente por debajo de lo esperado y afecta el ritmo de los equipos.";
      }
      setSummary({
        ...(data.summary || {}),
        total_projected_units: totalProj,
        total_executed_units: totalExec,
        compliance_pct: compliancePct,
        compliance_message: complianceMessage,
        compliance_color: complianceColor
      });
    }
  );
};

export const getManagementExecutedVsNOProjectedByProcessDATA = async (
  year,
  month,
  dateRange,
  setData,
  setDetailTotal,
  setDetailPage,
  page,
  ROWS_PER_PAGE,
  processId
) => {
  if (!year || !month) return;

  const { startDate, endDate } = parseWeekRange(dateRange || null);

  const start = startDate || "null";
  const end = endDate || "null";

  await callApiAsync(
    () =>
      getManagementExecutedVsNOProjectedByProcess(
        {
          year,
          month,
          start_date: start,
          end_date: end,
          user_id: userId,
          process_id: processId
        },
        page,
        ROWS_PER_PAGE
      ),
    (resp) => {
      const data = resp?.data ?? resp;
      setData(data.items || []);
      setDetailTotal(data.total || 0);
      setDetailPage(page);
    }
  );
};